import * as z from "zod";

export const createFulfillmentGroupComment = {
  name: "createFulfillmentGroupComment" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    message: z.string().trim().min(1).max(5000),
  }),
  output: z.object({ success: z.boolean() }),
};
